import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ModalController, ViewController} from 'ionic-angular';
import { Client } from '../../models/client';
import { Items } from '../../providers/items';

/**
 * Generated class for the AssignClientPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-assign-client',
  templateUrl: 'assign-client.html',
})
export class AssignClientPage {
  currentItems: Client[];
  administer: string;
  isClientSelected: boolean = false;
  client: Client;

  constructor(public navCtrl: NavController, public navParams: NavParams,
    public modalCtrl: ModalController, public items: Items, public viewCtrl: ViewController) {
    this.items.getClientList().subscribe(res => {
      if (res) {
        this.currentItems = res;
      }
    }, err => {
      console.error('ERROR', err);
    });
  }

  
  ionViewDidEnter() {
    
  }

  assignClient(){
    this.viewCtrl.dismiss({client_id: this.client.id, dismiss:'done'});
  }


  cancel() {
    this.viewCtrl.dismiss();
  }

  clientSelected(item) {
    if(item.selected){
      item.selected = false;
    }else{
      item.selected = true;
      this.isClientSelected = true;
      this.client = item;
      var id = item.id;
    }
    
  }

  filterClients(ev) {
    var val = ev.target.value;
    this.currentItems = this.items.getClients(val);
    return this.currentItems;

  }

  calculateAge(birthday) {
    if (birthday) {
      var timeDiff = Math.abs(Date.now() - Date.parse(birthday));
      //Used Math.floor instead of Math.ceil
      //so 26 years and 140 days would be considered as 26, not 27.
      return Math.floor((timeDiff / (1000 * 3600 * 24)) / 365);
    }
  }




}



// WEBPACK FOOTER //
// ./src/pages/assign-client/assign-client.ts